import type { UploadJob } from '@/stores/uploadJobStore';

/**
 * Where the Review action for a finished recording job should land.
 * Pure so it can be unit-tested and shared without a router.
 */
export function reviewPathFor(job: Pick<UploadJob, 'isEncounterMode' | 'encounterId' | 'appointmentId'>): string {
  if (job.isEncounterMode && job.encounterId) {
    return `/encounter/${job.encounterId}/validation`;
  }
  if (job.appointmentId) {
    return `/case/${job.appointmentId}/validation`;
  }
  return '/dashboard';
}
